import React from "react";
import { Component } from "react";
import Safe from "react-safe"
import { getLicenseRequest } from '../../Api/License';



const packageEnum = {
    '183a2eac-4846-458c-ad50-4d8417c7f589': 0, // FREE
    '42d2d830-111e-4d1b-88a4-b74596177085': 0, // free 500
    '38fc8037-30b6-476e-8c0f-4e845f1ca98b': 1, //BASE
    '35bcc7fe-dea3-4977-a9b5-f5a0e129d973': 2,//ESTANDAR
    '462a7117-3421-44a9-be57-a4d4e8d16aa7': 3//PROFESIONAL
}
const CORPORATIVO = 4;// 4 CORPORATIVO


class BannerControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            plan: null
        }
    }
    componentDidMount() {
        getLicenseRequest()
            .then(response => {
                if (response && response.status === 'success' && response.data) {
                    const { idPaquete } = response.data
                    const tipoPlan = packageEnum[idPaquete] !== undefined ? packageEnum[idPaquete] : CORPORATIVO;
                    this.setState({
                        plan: tipoPlan
                    })
                    localStorage.setItem('tipoPlan', tipoPlan)
                    window.gsc('params', {
                        plan: tipoPlan
                    });

                }

            })
            .catch(err => {
                this.setState({
                    plan: '1'
                })
                localStorage.setItem('tipoPlan', 1);
                window.gsc('params', {
                        plan: 1
                    });

            });

    }
    render() {
        let result = (<div></div>)

        if (this.state.plan != null) {
            result = (<div>

            </div>);
        }
        return result;

    }




}

export default BannerControl;